export const userStatuses = {
  VERIFIED: "verified",
  REJECTED: "rejected",
  AWAITING: "waiting_for_verification",
  BLOCKED: "blocked",
};
